import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext'; 
import { useLocation } from 'react-router-dom';

const RoleContext = createContext();

export const useRole = () => {
  return useContext(RoleContext);
};

export const RoleProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const baseURL = process.env.NODE_ENV === 'development'
  ?  process.env.REACT_APP_DEV_URL
  : 'https://revisaja-0b95e6e3ff11.herokuapp.com';

  useEffect(() => {
    const fetchRole = async () => {
      try {
        if (!currentUser) {
          setRole(null);
          setLoading(false);
          return;
        }

        if (location.pathname === '/' || location.pathname === '/termos' || location.pathname === '/quem-somos') {
          setLoading(false);
          return;
        }

        const token = await currentUser.getIdToken();

        const response = await fetch(`${baseURL}/roles`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Erro ao buscar a role do usuário.');
        }

        const data = await response.json();
        setRole(data.role || 'user');
      } catch (error) {
        //console.error('Erro ao buscar a role:', error.message);
        setRole('user');
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, [currentUser]);

  return (
    <RoleContext.Provider value={{ role, loading }}>
      {children}
    </RoleContext.Provider>
  );
};

